export default {
      id: "arrow-special-left-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-left",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-left.svg
// module id = 128
// module chunks = 241 242 243